import { Route, Routes } from "react-router-dom";
import M2Positions from "./M2Positions/main";
import M2Issuers from "./M2Issuers/main";
import M2StaticData from "./M2StaticData/main";
import M2DataUpload from "./M2DataUpload/main";
import { Tables } from "@/gen/tableNames/tables";
import { ClientTables } from "@/lib/clientTables";

export default function M2Routes() {
  return (
    <Routes>
      <Route path={`${Tables.M2_POSITIONS}/*`} element={<M2Positions />} />
      <Route path={`${Tables.M2_ISSUERS}/*`} element={<M2Issuers />} />
      <Route path={`${Tables.M2_STATIC_DATA}/*`} element={<M2StaticData />} />
      <Route
        path={`${ClientTables.M2_DATA_UPLOAD}/*`}
        element={<M2DataUpload />}
      />
    </Routes>
  );
}
